var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "tile is-ancestor is-parent" }, [
    _c("div", { staticClass: "tile" }, [
      _c("div", { staticClass: "tile is-parent is-half" }, [
        _c("article", { staticClass: "tile is-child box" }, [
          _vm._m(0),
          _c("div", { staticClass: "field" }, [
            _c("label", { staticClass: "label" }, [_vm._v("Item No.")]),
            _c("span", [
              _vm._v("Q" + _vm._s(_vm.$filters.pad(_vm.value.lineNumber, 3))),
            ]),
          ]),
          _c("div", { staticClass: "field" }, [
            _c("label", { staticClass: "label" }, [_vm._v("Description")]),
            _c("div", { staticClass: "control desc-width" }, [
              _c("textarea", {
                directives: [
                  { name: "focus-inserted", rawName: "v-focus-inserted" },
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.value.itemDesc,
                    expression: "value.itemDesc",
                  },
                ],
                staticClass: "textarea",
                class: { "is-danger": _vm.$v.entity.itemDesc.$error },
                attrs: {
                  placeholder: "Item Description",
                  rows: "3",
                  cols: "10",
                },
                domProps: { value: _vm.value.itemDesc },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.value, "itemDesc", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _vm.$v.entity && !_vm.$v.entity.itemDesc.required
                ? _c("span", { staticClass: "help is-danger" }, [
                    _vm._v("Description is required"),
                  ])
                : _vm._e(),
            ]),
          ]),
          _c("div", { staticClass: "field" }, [
            _c("div", { staticClass: "field-body" }, [
              _c("div", { staticClass: "field is-narrow" }, [
                _c("label", { staticClass: "label" }, [_vm._v("Quantity")]),
                _c(
                  "div",
                  { staticClass: "control" },
                  [
                    _c("vue-numeric", {
                      staticClass: "input has-text-right",
                      attrs: { min: 1, precision: 0 },
                      model: {
                        value: _vm.value.quantity,
                        callback: function ($$v) {
                          _vm.$set(_vm.value, "quantity", _vm._n($$v))
                        },
                        expression: "value.quantity",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "field" }, [
            _c("div", { staticClass: "field-body" }, [
              _c("div", { staticClass: "field is-narrow" }, [
                _c("label", { staticClass: "label" }, [_vm._v("Price")]),
                _c(
                  "div",
                  { staticClass: "control" },
                  [
                    _c("vue-numeric", {
                      staticClass: "input has-text-right",
                      attrs: { min: 0.0, precision: 2 },
                      model: {
                        value: _vm.value.price,
                        callback: function ($$v) {
                          _vm.$set(_vm.value, "price", _vm._n($$v))
                        },
                        expression: "value.price",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
          _vm.$user.hasDelete(_vm.$route.meta.id)
            ? _c("div", { staticClass: "is-divider" })
            : _vm._e(),
          _vm.$user.hasDelete(_vm.$route.meta.id)
            ? _c("div", { staticClass: "field" }, [
                _c("div", { staticClass: "buttons has-addons is-centered" }, [
                  _c(
                    "span",
                    {
                      staticClass: "button",
                      class: { "is-success is-selected": !_vm.value.deleted },
                      on: {
                        click: function ($event) {
                          return _vm.toggleActive(false)
                        },
                      },
                    },
                    [_vm._m(1), _c("span", [_vm._v("Active")])]
                  ),
                  _c(
                    "span",
                    {
                      staticClass: "button",
                      class: { "is-danger is-selected": _vm.value.deleted },
                      on: {
                        click: function ($event) {
                          return _vm.toggleActive(true)
                        },
                      },
                    },
                    [_vm._m(2), _c("span", [_vm._v("In-Active")])]
                  ),
                ]),
              ])
            : _vm._e(),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "columns is-gapless" }, [
      _c("div", { staticClass: "column" }, [
        _c("p", { staticClass: "title" }, [_vm._v("Detail Info")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "mdi mdi-check" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "mdi mdi-close" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }